/**
 * This file exists because of sonarqube-gate
 */
const strokeWidth = "stroke-width";
const strokeLinecap = "stroke-linecap";
const strokeLinejoin = "stroke-linejoin";
const fillRule = "fill-rule";

const commonGAttributes = {
  commonOne: [
    { stroke: "none" },
    { [strokeWidth]: "1" },
    { fill: "none" },
    { [fillRule]: "evenodd" },
    { [strokeLinecap]: "round" },
    { [strokeLinejoin]: "round" }
  ],
  commonTwo: [
    { stroke: "none" },
    { [strokeWidth]: "1" },
    { fill: "none" },
    { [fillRule]: "evenodd" }
  ],
  commonThree: [
    { fill: "none" },
    { [strokeWidth]: "1" },
    { stroke: "none" },
    { [fillRule]: "evenodd" },
    { width: "30px" },
    { height: "30px" }
  ],
  commonFour: [
    { stroke: "none" },
    { [strokeWidth]: "1" },
    { [strokeLinecap]: "round" },
    { fill: "none" },
    { [fillRule]: "evenodd" }
  ]
};

export default commonGAttributes;
